import { defineComponent as _defineComponent } from 'vue'
import BCXTable from '@/components/BCXTable.vue';
import { computed, PropType, toRef } from 'vue';

import MyProjectsContractFileTableButtons from '@/views/my-projects/components/contract/contractDocuments/MyProjectsContractFileTableButtons.vue';
import { ContractDocumentFile } from '@/models/Contracts';
import useUser from '@/mixins/useUser';
import useFormattedDateTime, { TimeFormatting } from '@/mixins/useFormattedDateTime';
import useContract from '@/views/my-projects/composables/useContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractFileTable',
  props: {
  contractFiles: {
    type: Array as PropType<ContractDocumentFile[]>,
    default: undefined
  }
},
  emits: ['delete-file', 'download-file', 'view-file'],
  setup(__props, { emit }) {

const props = __props;

const { getFormattedTimeByAge } = useFormattedDateTime();

const { userId } = useUser('self');
const {
  isContractStatusOpen, isUserClient, openContractDocumentId, contractDetail
} = useContract();

const fieldNames = ['versionNo', 'created', 'uploader'];



const sortCallback = (field: string, obj: any) => obj[field];
const displayCallback = (field: string, obj: any) => obj[field];

const isDocumentSigned = computed(() => {
  const document = contractDetail.value?.documents.find((document) => document.id === openContractDocumentId.value);
  if (!document) {
    return false;
  }

  return isUserClient.value ? document.signedByClient : document.signedByContractor;
});

// The file can only be deleted if the user has uploaded the file, the contract has the status open, the file is not marked as signed and has not been downloaded/viewed by the contractual partner.
const isFileDeletable = (file: ContractDocumentFile) => (file.creator?.userId ?? file.creator?.company?.rootUserId) === userId.value && isContractStatusOpen.value && !isDocumentSigned.value && !file.lastViewed;
// The file is marked as read if I am the uploader and lastViewed exists,
const isFileSeen = (file: ContractDocumentFile) => (file.creator?.userId ?? file.creator?.company?.rootUserId) === userId.value && !!file.lastViewed;
const isFilePdf = (file: ContractDocumentFile): boolean => file.externalFile?.fileType === 'application/pdf';

const contractFiles = toRef(props, 'contractFiles');
const contractFilesRows = computed(() => contractFiles.value.map((file) => ({
  id: file.id,
  versionNo: file.versionNo?.toString().padStart(2, '0') ?? '-',
  created: getFormattedTimeByAge(file.created, TimeFormatting.ChatMessageOverview),
  uploader: useUser(file.creator).displayName.value,
  deletable: isFileDeletable(file),
  hasItBeenSeen: isFileSeen(file),
  isFilePdf: isFilePdf(file)
})));

const deleteFile = (id: string) => {
  const file = contractFiles.value.find((file) => file.id === id);
  if (!file || !isFileDeletable(file)) {
    return;
  }
  emit('delete-file', id);
};

const downloadFile = (id: string) => {
  emit('download-file', id);
};

const viewFile = (id: string) => {
  emit('view-file', id);
};

return { __sfc: true,getFormattedTimeByAge, userId, isContractStatusOpen, isUserClient, openContractDocumentId, contractDetail, fieldNames, props, emit, sortCallback, displayCallback, isDocumentSigned, isFileDeletable, isFileSeen, isFilePdf, contractFiles, contractFilesRows, deleteFile, downloadFile, viewFile, BCXTable, MyProjectsContractFileTableButtons }
}

})